import { render, staticRenderFns } from "./enableAndDisableDialog.vue?vue&type=template&id=6070527c&scoped=true"
import script from "./enableAndDisableDialog.vue?vue&type=script&lang=js"
export * from "./enableAndDisableDialog.vue?vue&type=script&lang=js"
import style0 from "./enableAndDisableDialog.vue?vue&type=style&index=0&id=6070527c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6070527c",
  null
  
)

export default component.exports